import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import {loader, toastr} from '../CommonActions';
import { store } from '../../../services/store.service';
import { history } from '../../../helpers/history';
import { auth } from '../../../services/auth.service';
export const GET_CART_ITEMS = 'GET_CART_ITEMS';
export const ADD_PRODUCT_TO_CART = 'ADD_PRODUCT_TO_CART';
export const UPDATE_PRODUCT_TO_CART = 'UPDATE_PRODUCT_TO_CART';
export const DELETE_PRODUCT_FROM_CART = 'DELETE_PRODUCT_FROM_CART';
export const UPDATE_CARD = 'UPDATE_CARD';
export const UPDATE_BILLING = 'UPDATE_BILLING';
export const UPDATE_SHIPPING = 'UPDATE_SHIPPING';
export const COMPLETE_PURCHASE = 'COMPLETE_PURCHASE';
export const UPDATE_PURCHASE_MESSAGE = 'UPDATE_PURCHASE_MESSAGE';
export const ADD_CART_ITEM = 'ADD_CART_ITEM';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const UPDATE_PRODUCT_QUANTITY = 'UPDATE_PRODUCT_QUANTITY';
export const ADD_TRANSACTION_ID = 'ADD_TRANSACTION_ID';

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";

export function getCartItems() {
    return function (dispatch) {
        dispatch({
            type: GET_CART_ITEMS,
            cartItems: store.getSelectedProducts(),
            cartTotal: store.getCartQty()
        });
   }
}

export function addtoCart(product, cartItems) 
{
    return function (dispatch) {
        var found = false;
        for (var i = 0; i < cartItems.length; i++) {
            if (cartItems[i].ProductId === product.ProductId && cartItems[i].ColorId === product.ColorId && cartItems[i].SizeId === product.SizeId) {
                var stateCopy = Object.assign([], cartItems);
                stateCopy[i].Quantity += parseInt(product.Quantity,0);
                stateCopy[i].Cost = product.Cost;
                store.setSelectedProduct(stateCopy);
                dispatch({
                    type: ADD_CART_ITEM,
                    cartItems: stateCopy,
                    cartTotal: store.getCartQty()
                })
                found = true;
                break;
            } 
        }
        
        if (!found) {
            store.setSelectedProduct([...cartItems, product]);
            dispatch({
                type: ADD_CART_ITEM,
                cartItems: [...cartItems, product],
                cartTotal: store.getCartQty()
            }) 
        }             
   }
}

export function addProducttoCart(model) {
    return function (dispatch) {
        axios.post(`${ROOT_API_URL}/Product/AddProducttoCart`, model)
            .then((response) => dispatch({
                type: ADD_PRODUCT_TO_CART,
                cartItems: response.data.cartItems,
                cartTotal: store.getCartQty()
            })).catch((response) => {
                console.log(response);
            })
    }
}

export function updateCard(cardObject) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_CARD,
            creditCard: cardObject
        })
    }
}

export function updateBilling(billingInfo) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_BILLING,
            billingInfo: billingInfo
        })
    }
}

export function updateShipping(shippingInfo) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_SHIPPING,
            shippingInfo: shippingInfo
        })
    }
}

export function toggleToastr(visible) {
    return function (dispatch) {
        dispatch(toastr(visible, '', errorColor));
    }
}

export function completePurchase(model,authr) {
    return function (dispatch) {
        return new Promise((resolve, reject) => {
            // gets error 'can't get cartViewModel of null' at the end of axios call
            // this is why it throws an exception at the end of a successful order
            // does not affect the functionality of the application however
            var orderModel = {
                UserId: model.UserId,
                Subtotal: Number(model.Subtotal),
                Tax: Number(model.Tax),
                Shipping: Number(model.Shipping),
                TotalCost: Number(model.TotalCost),
                OrderViewModel: {
                    Address1: model.shippingInfo.Address1,
                    Address2: model.shippingInfo.Address2,
                    City: model.shippingInfo.City,
                    Zip: model.shippingInfo.Zip,
                    StateId: model.shippingInfo.StateId,
                    MembershipId: authr.membershipId,
                },
                PaymentBillingViewModel: {
                    ...model.billingInfo,
                    CardInfo: model.creditCard
                },
                CartViewModel: model.cartItems
            };
            dispatch(loader(true));
            let t = auth;
            axios.post(`${ROOT_API_URL}/Product/OrderCheckOut`, orderModel, { headers: auth.authHeader() })
                .then((response) => {
                    if (response && response.data && response.data.isSuccess) {

                        dispatch({
                            type: ADD_TRANSACTION_ID,
                            transactionId: response.data.transactionId
                        });
                        sessionStorage.removeItem("selectedProducts");
                        var success = response && response.data ? response.data.message : 'Order Placed Successfully';
                        dispatch(toastr(true, success, successColor));

                        dispatch({
                            type: COMPLETE_PURCHASE,
                            response: response,
                            message: 'Order Placed Successfully.'
                        });
                        history.push('/');
                        dispatch(loader(false));
                        resolve();
                    }
                    else {
                        var err = response && response.data ? response.data.message : "Error Finalizing Checkout";
                        dispatch(loader(false));
                        dispatch(toastr(true, err, warningColor, false));
                        reject('Error Finalizing Checkout');
                    }
                }).catch((response) => {
                    // Show response.message by default. Use response.response.data.exceptionLanguage if exists
                    var err = response.message ? response.message : 'Network Connection Error';

                    if (response.response && response.response.data && response.response.data.exceptionLanguage) {
                        err = response.response.data.exceptionLanguage;
                    }

                    dispatch(loader(false));
                    dispatch(toastr(true, err, errorColor, false));
                    reject(err);
                })
        });
    }
}

export function setTransactionId(transactionId) {
    return function (dispatch) {
        dispatch({
            type: ADD_TRANSACTION_ID,
            transactionId: transactionId
        });
    }
}

export function removeProductFromCart(product, cartItems) {
    return function (dispatch) {
        for (var i = 0; i < cartItems.length; i++) {
            if (cartItems[i].ProductId === product.ProductId && cartItems[i].ColorId === product.ColorId && cartItems[i].SizeId === product.SizeId) {
                var p = cartItems.splice(i, 1); //Remove the element from the array
                var stateCopy = Object.assign([], cartItems);
                store.setSelectedProduct(stateCopy);
                dispatch({
                    type: REMOVE_CART_ITEM,
                    cartItems: stateCopy,
                    cartTotal: store.getCartQty()
                })
                break;
            }
        }
    }
}

export function updateProductInCart(product, cartItems) {
    return function (dispatch) {
        for (var i = 0; i < cartItems.length; i++) {
            if (cartItems[i].ProductId === product.ProductId && cartItems[i].ColorId === product.ColorId && cartItems[i].SizeId === product.SizeId) {
                cartItems[i].Quantity = product.Quantity;
                store.setSelectedProduct(cartItems);
                dispatch({
                    type: UPDATE_PRODUCT_QUANTITY,
                    cartItems: cartItems,
                    cartTotal: store.getCartQty()
                })
                break;
            }
        }
    }
}


